<template>
    <div>
        <span class="digital-classrooms-event__date-range">{{ eventDateRange }}</span>
        <span :class="['digital-classrooms-event__show-dates-and-times', {'signed' : isUserSignedToEvent}]" @click="toggleDatesDropDown">
            <span v-html="$t('DigitalClassrooms.show_dates_and_times')"></span>
            <span :class="['icon-chevron-down', getClassForDateDropDown]"></span>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        eventDateRange: String,
        isUserSignedToEvent: Boolean,
        showDateDropDown: Boolean
    },
    data () {
        return {
            showDatesDropDown: false
        }
    },
    computed: {
        getClassForDateDropDown () {
            return this.showDateDropDown ? 'open' : 'close'
        }
    },
    methods: {
        toggleDatesDropDown() {
            this.$emit('toggleDatesDropDown')
        }
    }
}
</script>

<style lang="scss" scoped>
.icon-chevron-down {
    display: inline-block;
    &.open {
        transition: transform 0.3s ease;
        transform: rotate(-180deg);
    }
    &.close {
        transform: rotate(0deg);
        transition: transform 0.3s linear;
    }
}
@include digital-classrooms-table;
@include digital-classrooms-event;
</style>
